import { all, call, put, takeLeading } from 'typed-redux-saga'
import {
	ActModel,
	ActsApi,
	actSlice,
	actStatusesNS,
	actStatusesSlice,
	StatusActModel,
} from 'Pages/acts'
import { errorHandler, loadersSlice } from 'Modules'
import { ResponseCatalog } from 'Models'
import { Deserialize } from 'cerialize'

function* patchActUpdateStatusSaga(data: { id: number; status_slug: string }) {
	const { id, status_slug } = data
	const newAct = yield* call(ActsApi.patchActUpdataStatus, id, status_slug)
	yield* put(actSlice.actions.setAct(Deserialize(newAct, ActModel)))
}

function* patchActUpdataStatusSaga(action: actStatusesNS.patchActUpdataStatus) {
	try {
		const { arrId, status_slug, callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* all(arrId.map((id) => call(patchActUpdateStatusSaga, { id, status_slug })))
		callback?.()
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getActStatusesSelectSaga() {
	try {
		const res = yield* call(ActsApi.getActStatuses)
		const statuses = new ResponseCatalog<StatusActModel>()
		statuses.entries = res.map((status): StatusActModel => Deserialize(status, StatusActModel))
		yield* put(actStatusesSlice.actions.setActStatusesSelect(statuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const actStatusesSaga = function* saga() {
	yield* takeLeading(actStatusesSlice.actions.getActStatusesSelect.type, getActStatusesSelectSaga)
	yield* takeLeading(actStatusesSlice.actions.patchActUpdataStatus.type, patchActUpdataStatusSaga)
}
